{
  "id": "sky_meadow_01",
  "name": "Sky Meadow",
  "theme": "sky_meadow",
  "targetSeconds": 60,
  "spawn": { "x": 64, "y": 640 },
  "finishX": 18880,
  "killY": 960,
  "segments": [
    { "type": "checkpoint", "x": 64, "y": 640 },
    {
      "type": "ground",
      "x": 0,
      "y": 640,
      "w": 864,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    { "type": "gap", "x": 864, "w": 96 },
    {
      "type": "ground",
      "x": 960,
      "y": 640,
      "w": 3200,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "shard_trail",
      "x": 736,
      "y": 560,
      "count": 7,
      "spacing": 32,
      "shape": "arc",
      "arcHeight": 64
    },
    { "type": "obstacle", "x": 1216, "y": 576, "w": 64, "h": 64, "kind": "crate" },
    { "type": "item_box", "x": 1248, "y": 512 },
    { "type": "decor", "id": "flower_giant", "x": 288, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "mushroom_tree", "x": 704, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "flower_giant", "x": 1088, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "waterfall_far", "x": 1408, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "grass_tuft", "x": 192, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "grass_tuft", "x": 992, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "rock_small", "x": 1504, "y": 640, "layer": "fg" },
    {
      "type": "ramp",
      "x": 1760,
      "y": 448,
      "w": 256,
      "h": 128,
      "dir": "up",
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 2016,
      "y": 448,
      "w": 1184,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 3392,
      "y": 448,
      "w": 192,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 3584,
      "y": 448,
      "w": 256,
      "h": 128,
      "dir": "down",
      "style": "stone_slab",
      "supports": "auto"
    },
    { "type": "speed_strip", "x": 2304, "y": 448, "w": 512 },
    {
      "type": "shard_trail",
      "x": 2912,
      "y": 352,
      "count": 6,
      "spacing": 32,
      "shape": "grid",
      "rows": 3
    },
    {
      "type": "shard_trail",
      "x": 3200,
      "y": 400,
      "count": 7,
      "spacing": 32,
      "shape": "arc",
      "arcHeight": 96
    },
    { "type": "spiked_stone", "x": 3456, "y": 448 },
    { "type": "item_box", "x": 2496, "y": 384 },
    { "type": "item_box", "x": 2048, "y": 512 },
    { "type": "slow_strip", "x": 2208, "y": 640, "w": 384 },
    { "type": "stake_barricade", "x": 2432, "y": 640, "w": 64 },
    { "type": "obstacle", "x": 2784, "y": 576, "w": 96, "h": 64, "kind": "barrel_row" },
    { "type": "obstacle", "x": 2976, "y": 576, "w": 64, "h": 64, "kind": "crate" },
    { "type": "obstacle", "x": 3040, "y": 576, "w": 64, "h": 64, "kind": "crate" },
    { "type": "obstacle", "x": 3040, "y": 512, "w": 64, "h": 64, "kind": "crate" },
    { "type": "item_box", "x": 3008, "y": 448 },
    { "type": "decor", "id": "flower_giant", "x": 1792, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "ruin_arch", "x": 2400, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "flower_giant", "x": 2880, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "mushroom_tree", "x": 3456, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "moss_clump", "x": 2112, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "grass_tuft", "x": 2656, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "rock_small", "x": 3712, "y": 640, "layer": "fg" },
    { "type": "gap", "x": 4160, "w": 640 },
    {
      "type": "platform",
      "x": 4192,
      "y": 672,
      "w": 96,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    { "type": "bounce_pad", "x": 4192, "y": 672, "w": 96 },
    {
      "type": "platform",
      "x": 4512,
      "y": 672,
      "w": 128,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    { "type": "bounce_pad", "x": 4512, "y": 672, "w": 128 },
    {
      "type": "platform",
      "x": 4192,
      "y": 512,
      "w": 608,
      "h": 32,
      "style": "log",
      "supports": "auto"
    },
    { "type": "shard_trail", "x": 4224, "y": 472, "count": 18, "spacing": 32, "shape": "line" },
    { "type": "speed_strip", "x": 4320, "y": 512, "w": 352 },
    { "type": "item_box", "x": 4416, "y": 448 },
    {
      "type": "ground",
      "x": 4800,
      "y": 640,
      "w": 1920,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    { "type": "spiked_stone", "x": 5312, "y": 640 },
    { "type": "obstacle", "x": 5600, "y": 576, "w": 64, "h": 64, "kind": "crate" },
    { "type": "obstacle", "x": 5664, "y": 576, "w": 64, "h": 64, "kind": "crate" },
    { "type": "item_box", "x": 5760, "y": 512 },
    { "type": "checkpoint", "x": 6272, "y": 640 },
    { "type": "decor", "id": "mushroom_tree", "x": 4096, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "vine_curtain", "x": 4480, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "mushroom_tree", "x": 5024, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "mushroom_tree", "x": 5504, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "flower_giant", "x": 5984, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "mushroom_small", "x": 4864, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "mushroom_small", "x": 5440, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "glow_fungus", "x": 6080, "y": 640, "layer": "fg" },
    { "type": "gap", "x": 6720, "w": 192 },
    {
      "type": "ground",
      "x": 6912,
      "y": 640,
      "w": 384,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    { "type": "gap", "x": 7296, "w": 256 },
    {
      "type": "crumbling_platform",
      "x": 7296,
      "y": 640,
      "w": 128,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "crumbling_platform",
      "x": 7424,
      "y": 640,
      "w": 128,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "ground",
      "x": 7552,
      "y": 640,
      "w": 448,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    { "type": "gap", "x": 8000, "w": 160 },
    {
      "type": "ground",
      "x": 8160,
      "y": 640,
      "w": 1440,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "shard_trail",
      "x": 6720,
      "y": 560,
      "count": 7,
      "spacing": 32,
      "shape": "arc",
      "arcHeight": 96
    },
    {
      "type": "shard_trail",
      "x": 8000,
      "y": 560,
      "count": 6,
      "spacing": 32,
      "shape": "arc",
      "arcHeight": 64
    },
    { "type": "obstacle", "x": 6464, "y": 576, "w": 64, "h": 64, "kind": "crate" },
    {
      "type": "platform",
      "x": 6592,
      "y": 448,
      "w": 1280,
      "h": 32,
      "style": "log",
      "supports": "auto"
    },
    {
      "type": "moving_platform",
      "x": 7872,
      "y": 448,
      "w": 96,
      "h": 32,
      "dx": 0,
      "dy": 96,
      "periodTicks": 90,
      "style": "log",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 7968,
      "y": 448,
      "w": 640,
      "h": 32,
      "style": "log",
      "supports": "auto"
    },
    { "type": "speed_strip", "x": 6720, "y": 448, "w": 896 },
    { "type": "speed_strip", "x": 8064, "y": 448, "w": 416 },
    { "type": "shard_trail", "x": 6624, "y": 400, "count": 20, "spacing": 64, "shape": "line" },
    {
      "type": "shard_trail",
      "x": 7840,
      "y": 384,
      "count": 5,
      "spacing": 32,
      "shape": "arc",
      "arcHeight": 64
    },
    {
      "type": "log_ram",
      "x": 8416,
      "y": 224,
      "lengthPx": 200,
      "amplitudeDeg": 60,
      "periodTicks": 54,
      "phaseTicks": 0
    },
    { "type": "item_box", "x": 7712, "y": 384 },
    {
      "type": "boulder_drop",
      "x": 7616,
      "y": 320,
      "w": 64,
      "h": 64,
      "dropPx": 256,
      "periodTicks": 120,
      "phaseTicks": 30
    },
    { "type": "item_box", "x": 8416, "y": 512 },
    { "type": "checkpoint", "x": 9472, "y": 640 },
    { "type": "decor", "id": "flower_giant", "x": 6624, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "waterfall_big", "x": 7104, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "mushroom_tree", "x": 7936, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "vine_curtain", "x": 8544, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "flower_giant", "x": 9120, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "reeds", "x": 6688, "y": 672, "layer": "fg" },
    { "type": "decor", "id": "lily_pads", "x": 7264, "y": 672, "layer": "fg" },
    { "type": "decor", "id": "reeds", "x": 7968, "y": 672, "layer": "fg" },
    { "type": "decor", "id": "grass_tuft", "x": 9024, "y": 672, "layer": "fg" },
    {
      "type": "ground",
      "x": 9600,
      "y": 640,
      "w": 3424,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    { "type": "obstacle", "x": 9760, "y": 544, "w": 64, "h": 96, "kind": "crate" },
    { "type": "stake_barricade", "x": 9888, "y": 640, "w": 64 },
    { "type": "stake_barricade", "x": 10592, "y": 640, "w": 64 },
    { "type": "trapdoor", "x": 11200, "y": 640, "w": 96, "periodTicks": 75, "phaseTicks": 0 },
    { "type": "slow_strip", "x": 11488, "y": 640, "w": 416 },
    { "type": "obstacle", "x": 12096, "y": 576, "w": 64, "h": 64, "kind": "rock" },
    { "type": "obstacle", "x": 12160, "y": 576, "w": 64, "h": 64, "kind": "rock" },
    { "type": "item_box", "x": 10304, "y": 512 },
    {
      "type": "platform",
      "x": 10016,
      "y": 448,
      "w": 1600,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 11840,
      "y": 448,
      "w": 544,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 11584,
      "y": 448,
      "w": 256,
      "h": 128,
      "dir": "up",
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 12384,
      "y": 448,
      "w": 256,
      "h": 128,
      "dir": "down",
      "style": "stone_slab",
      "supports": "auto"
    },
    { "type": "speed_strip", "x": 10304, "y": 448, "w": 512 },
    { "type": "spiked_stone", "x": 11008, "y": 448 },
    {
      "type": "platform",
      "x": 10912,
      "y": 320,
      "w": 576,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "shard_trail",
      "x": 10976,
      "y": 192,
      "count": 8,
      "spacing": 32,
      "shape": "grid",
      "rows": 4
    },
    { "type": "item_box", "x": 11200, "y": 256 },
    { "type": "decor", "id": "ruin_wall", "x": 9728, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "pitcher_plant", "x": 10240, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "thorn_vine_wall", "x": 10816, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "ruin_arch", "x": 11520, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "pitcher_plant", "x": 12224, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "ruin_wall", "x": 12800, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "thorny_branch", "x": 10048, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "pottery_broken", "x": 11072, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "thorny_branch", "x": 12480, "y": 640, "layer": "fg" },
    {
      "type": "ground",
      "x": 13024,
      "y": 640,
      "w": 6976,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 13312,
      "y": 576,
      "w": 192,
      "h": 64,
      "dir": "up",
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 13504,
      "y": 576,
      "w": 192,
      "h": 64,
      "dir": "down",
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 13824,
      "y": 576,
      "w": 192,
      "h": 64,
      "dir": "up",
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 14016,
      "y": 576,
      "w": 192,
      "h": 64,
      "dir": "down",
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 14464,
      "y": 576,
      "w": 192,
      "h": 64,
      "dir": "up",
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 14656,
      "y": 576,
      "w": 192,
      "h": 64,
      "dir": "down",
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "boulder_drop",
      "x": 14272,
      "y": 320,
      "w": 64,
      "h": 64,
      "dropPx": 256,
      "periodTicks": 120,
      "phaseTicks": 60
    },
    {
      "type": "platform",
      "x": 13152,
      "y": 576,
      "w": 96,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    { "type": "bounce_pad", "x": 13152, "y": 576, "w": 96 },
    {
      "type": "platform",
      "x": 13344,
      "y": 448,
      "w": 1248,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 14784,
      "y": 448,
      "w": 416,
      "h": 32,
      "style": "stone_slab",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 15200,
      "y": 448,
      "w": 256,
      "h": 128,
      "dir": "down",
      "style": "stone_slab",
      "supports": "auto"
    },
    { "type": "speed_strip", "x": 13440, "y": 448, "w": 960 },
    { "type": "speed_strip", "x": 14848, "y": 448, "w": 288 },
    {
      "type": "shard_trail",
      "x": 14144,
      "y": 352,
      "count": 6,
      "spacing": 32,
      "shape": "grid",
      "rows": 3
    },
    {
      "type": "shard_trail",
      "x": 14592,
      "y": 400,
      "count": 7,
      "spacing": 32,
      "shape": "arc",
      "arcHeight": 96
    },
    { "type": "item_box", "x": 13696, "y": 512 },
    { "type": "item_box", "x": 14080, "y": 384 },
    { "type": "checkpoint", "x": 15488, "y": 640 },
    { "type": "speed_strip", "x": 16000, "y": 640, "w": 192 },
    { "type": "speed_strip", "x": 17184, "y": 640, "w": 192 },
    { "type": "speed_strip", "x": 18240, "y": 640, "w": 192 },
    { "type": "item_box", "x": 16128, "y": 576 },
    { "type": "item_box", "x": 17280, "y": 576 },
    { "type": "shard_trail", "x": 16224, "y": 600, "count": 12, "spacing": 64, "shape": "line" },
    { "type": "shard_trail", "x": 17440, "y": 600, "count": 8, "spacing": 64, "shape": "line" },
    { "type": "decor", "id": "floating_island", "x": 13568, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "flower_arch", "x": 14336, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "flower_giant", "x": 15616, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "flower_arch", "x": 16416, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "flower_giant", "x": 17280, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "finish_island", "x": 18880, "y": 640, "layer": "mid" },
    { "type": "decor", "id": "flower_bush", "x": 13760, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "grass_tuft", "x": 15104, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "flower_bush", "x": 16640, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "flag_celebration", "x": 17856, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "flag_celebration", "x": 18560, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "flag_celebration", "x": 19136, "y": 640, "layer": "fg" }
  ]
}
